import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: `
    <mat-dialog-content>
      <div class="flex align-itens-center width-100 justify-content-start">
        <h5 class="mb-0 font-weight-light d-flex align-items-center">
          <mat-icon *ngIf="data.icon" class="ml-2" [color]="data.icon_color">
            {{ data.icon }}
          </mat-icon>
          {{ data.titulo }}
        </h5>
      </div>
      <p>{{ data.msg }} ?</p>
    </mat-dialog-content>

    <div matDialogActions class="w-100 d-flex justify-content-between">
      <button
        [matDialogClose]="false"
        id="denny-btn"
        mat-stroked-button
        color="primary"
        type="button"
      >
        Cancelar
      </button>
      <button
        [matDialogClose]="true"
        id="confirm-btn"
        mat-flat-button
        color="primary"
        type="submit"
      >
        Confirmar
      </button>
    </div>
  `
})
export class DialogConfirmComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      titulo: string;
      msg: string;
      icon?: boolean;
      icon_color?: string;
    }
  ) {}
}
